<lib-card classes="shadow-xs px-[20px] w-[296px] mr-[16px]">
  <div class="flex flex-col gap-y-[8px]">
    <a *ngFor="let option of options"
       [attr.disabled]="option.isDisabled"
       [class]="twMerge('flex gap-x-[16px] px-[16px] py-[12px] heading-14 items-center rounded-[4px] font-medium',
        isCurrentRouteActive(option.link) ? 'bg-emerald-100 text-emerald-600' : 'text-blue-gray-800',
        option.isDisabled ? 'text-blue-gray-400 cursor-not-allowed' : ''
       )"
       routerLinkActive="bg-emerald-100 text-emerald-600"
       [routerLink]="!option.isDisabled ? option.link : null">

      <ng-container appDynamicIcon
                    [value]="!option.isDisabled"
                    [iconName]="option.iconName"
                    [iconClasses]="twMerge('',
        option.isDisabled ? 'fill-blue-gray-300' : '',
        isCurrentRouteActive(option.link) ? 'fill-emerald-600' : 'fill-blue-gray-800')"></ng-container>
      {{option.label}}
    </a>
  </div>
</lib-card>
